import React from 'react'

import Button from '@components/buttons/Button'

import './ButtonIconText.css'

interface ButtonIconTextProps {
	id?: string
	icon: string
	text: string
	invertIcon?: boolean
	onClick: (e: React.MouseEvent<HTMLButtonElement>) => void
	/** Show a spinner and refuse further clicks while the action is in flight. */
	loading?: boolean
}

function ButtonIconText(props: ButtonIconTextProps) {
	if (props.invertIcon) {
		return (
			<div id={props.id} className='buttonIconAndText invert'>
				<Button onClick={props.onClick} loading={props.loading}>
					<span className='buttonContent'>
						{props.text}
						<img src={props.icon} alt={props.text} />
					</span>
				</Button>
			</div>
		)
	}

	return (
		<div className='buttonIconAndText'>
			<Button id={props.id} onClick={props.onClick} loading={props.loading}>
				<span className='buttonContent'>
					<img src={props.icon} alt={props.text} />
					{props.text}
				</span>
			</Button>
		</div>
	)
}

export default ButtonIconText
